import {URLParams} from '../../initialize/initialize';

//メートル単位で2点間の距離を返却する
export function calc_distance(lat1, lng1, lat2, lng2) {
  lat1 *= Math.PI / 180
  lng1 *= Math.PI / 180
  lat2 *= Math.PI / 180
  lng2 *= Math.PI / 180
  let len = Math.floor(6371.137 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2)) * 1000);
  return isNaN(len)? 0 : len
}


//2点間距離の移動速度を算出
export function calc_velocity(l2, l1, t2, t1) {
    if (t1 == 0)
      return 0;
    else {
      let dt = (Date.parse('2020/01/01 ' + t2) - Date.parse('2020/01/01 ' + t1)) / 1000;
      return (-1 * (l2 - l1) / parseFloat(dt));//符号反転（近づくとマイナスになるから）
    }
}


//強制発報を許可
export function is_force() {
  let params = new URLSearchParams(window.location.search);
  return params.get('is_force') === '1';
}

//----- GLOCAL Param ------------------------------------
//名前パラメタの有無
export function guest_name(){
  return URLParams()['guest_name']
}

//電話番号パラメタの有無
export function phone_number(){
  return URLParams()['phone_number']
}

//OTA予約番号
export function confirm_number(){
  return URLParams()['confirm_number']
}

//予約日
export function checkin_date(){
  return URLParams()['checkin_date']
}

//施設名
export function house_name(){
  return URLParams()['house_name']
}
//自動追跡モード
export function auto_track(){
  if(URLParams()['auto_track']==="1"){
    return true
  } else {
    return false
  }
}
